import { IApplicationState } from '../../types/redux';
import { getDeveloper } from '../developer';

export function getRegions(state: IApplicationState) {
  const developer = getDeveloper(state);

  return developer.regions;
}
